/* eslint-disable max-lines-per-function */

import { E2NTableCell, E2NtableHeader } from '@/components/Table';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableRow } from '@/components/ui/table';
import { AvatarBox } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/AvatarBox';
import { FristenActions } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenTable/FristenActions';
import { FristenComment } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/FristenTable/FristenComment';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { cn } from '@/lib/utils';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export function FristenTable({ readonly = false }: { readonly?: boolean }) {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();

  return (
    <form.Subscribe
      selector={(state) => state.values.anstellungsverhaeltnis.fristen}>
      {(fristen) =>
        fristen.length > 0 && (
          <div className="hidden md:flex w-full">
            <Table>
              <E2NtableHeader>
                <E2NTableCell>
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.fristdatum.label',
                  )}
                </E2NTableCell>
                <E2NTableCell>
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.label',
                  )}
                </E2NTableCell>
                <E2NTableCell>
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungsZeit.label',
                  )}
                </E2NTableCell>
                <E2NTableCell>
                  {t(
                    'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungAn.label',
                  )}
                </E2NTableCell>
                <E2NTableCell></E2NTableCell>
              </E2NtableHeader>
              <TableBody className="border-y border-neutrals-300">
                {fristen.map((frist, index) => (
                  <TableRow key={index} className="group border-y p-5 ">
                    <E2NTableCell className="py-5">
                      {new Date(frist.fristdatum!).toLocaleDateString()}
                    </E2NTableCell>
                    <E2NTableCell>
                      {t(
                        `domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.grund.options.${frist.grund}`,
                      )}
                    </E2NTableCell>
                    <E2NTableCell>
                      {frist.erinnerungsZeit
                        .map((zeit) =>
                          t(
                            `domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.form.erinnerungsZeit.options.${zeit}`,
                          ),
                        )
                        .join(', ')}
                    </E2NTableCell>
                    <E2NTableCell>
                      {frist.erinnerungAn.length > 0 && (
                        <Suspense
                          fallback={<Skeleton className="h-8 w-full" />}>
                          <AvatarBox managerIds={frist.erinnerungAn} />
                        </Suspense>
                      )}
                    </E2NTableCell>
                    <E2NTableCell>
                      <div className="flex items-center gap-1">
                        {frist.bemerkung && (
                          <FristenComment bemerkung={frist.bemerkung} />
                        )}
                        <FristenActions
                          index={index}
                          className={cn(readonly && 'hidden', 'ml-auto')}
                        />
                      </div>
                    </E2NTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )
      }
    </form.Subscribe>
  );
}
